import React from 'react';
export function Methodology() {
  return <section id="methodology" className="py-16 bg-ink/5 hairline-t hairline-b" data-id="element-237">
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:pl-24 lg:pr-8" data-id="element-238">
        <div className="font-mono text-xs" data-id="element-239">
          <div className="flex items-center gap-4 text-ink/40 mb-8 tracking-widest" data-id="element-240">
            <span data-id="element-241">TRANSMISSION LOG</span>
            <div className="h-px flex-grow bg-ink/20" data-id="element-242" />
            <span data-id="element-243">ORIGIN: WAYDEV_SYS</span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-8" data-id="element-244">
            <div className="md:col-span-3 text-ink/50" data-id="element-245">
              <p className="mb-2" data-id="element-246">STATUS: ACTIVE</p>
              <p className="mb-2" data-id="element-247">CLASS: PUBLIC_BROADCAST</p>
              <p data-id="element-248">ENCRYPTION: NONE</p>
            </div>

            <div className="md:col-span-9 space-y-4 text-ink/70 leading-relaxed max-w-3xl" data-id="element-249">
              <p data-id="element-250">
                This guide is produced and maintained by Waydev to help
                engineering leaders navigate the complex landscape of
                engineering intelligence tools.
              </p>
              <p data-id="element-251">
                The data presented is gathered through public documentation,
                product demos, and user interviews. While we strive for
                accuracy, these platforms evolve rapidly. As the maker of
                Waydev, we naturally highlight the areas where our comprehensive
                platform excels, but we aim to provide a fair representation of
                all tools' strengths.
              </p>
              <p data-id="element-252">
                If you're looking for an all-in-one platform that covers DORA,
                SPACE, and R&D capitalization without the need to stitch
                multiple tools together, we'd love to show you what we've built.
              </p>
              <div className="pt-6" data-id="element-253">
                <a href="https://waydev.co/demo" target="_blank" rel="noopener noreferrer" className="inline-block bg-lime text-base px-6 py-3 font-bold hover:bg-ink transition-colors" data-id="element-254">
                  [ INITIATE WAYDEV DEMO ]
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}